<!-- src/App.vue -->
<template>
  <Particles />
  <GetStarted />
</template>

<script setup>
import GetStarted from "../components/GetStarted";
import Particles from "../components/Particles";

import { useHead } from '@vueuse/head'

useHead({
  title: 'Grapefroot | Get started',
  meta: [
    {
      name: 'description',
      content: 'Meta description',
    },
  ],
})


</script>
